import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=7a9f51d0&scoped=true"
import script from "./list2.vue?vue&type=script&lang=js"
export * from "./list2.vue?vue&type=script&lang=js"
import style0 from "./list2.vue?vue&type=style&index=0&id=7a9f51d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f51d0",
  null
  
)

export default component.exports